// NOTE: all messages here need to be unique as to allow for Sentry to group them per that uniqe text
// NOTE: they also must be use only once, e.g. CAP_EXAMPLE_1 should not be found in more than one place outside this file

// SEE: src/actions/pos/beInitReaderPayment.action.js
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';

const L = logger('apDepositUpdaterFor'); // eslint-disable-line no-unused-vars

export const CAP_POS_INIT_READER = 'failed validation for POS reader ID options';
export const CAP_POS_INVALID_READER = 'invalid readerId';
export const CAP_POS_DETERMINE_READER = 'failed retrieving the POS reader ID';

// SEE: src/components/pos/PosReaderDialog.component.jsx
export const CAP_POS_CANCEL = 'failed cancelling the POS transaction';
export const CAP_POS_LOOP = 'failed within the POS transaction loop';

const NONE = Object.freeze({ info: false, warn: false, error: false });
const DEFAULT = Object.freeze({ info: true, warn: true, error: true });

export const checkCapFlag = (options) => {
  const prefix = fromAnyToTrimmed(options?.prefix);

  if (!prefix) {
    L.warn('Invalid prefix:', options?.prefix, 'returning', NONE);
    return NONE;
  }

  const flags = options?.flags ?? {};

  const inf = flags[`${prefix}.info`];
  const wrn = flags[`${prefix}.warn`];
  const err = flags[`${prefix}.error`];

  if (inf === void 1 && wrn === void 1 && err === void 1) return DEFAULT;

  const info = true === inf;
  const warn = info || true === wrn;
  const error = warn || true === err;

  return { info, warn, error };
};

checkCapFlag.NONE = NONE;
checkCapFlag.DEFAULT = DEFAULT;
